module.exports = __webpack_public_path__ + "media/images/shopify-2caf1848e37e933895a297e755eb358d.svg";